module.exports = "<div class=\"widget-wrapper wow fadeIn\" data-wow-delay=\"0.2s\">\n  <br>\n  <div class=\"list-group\">\n    <a class=\"list-group-item active\" [routerLink]=\"['/web-dich/danh-sach']\">Danh sách</a>\n  </div>\n</div>\n<div class=\"widget-wrapper wow fadeIn\" data-wow-delay=\"0.2s\">\n  <div class=\"list-group\">\n\n    <a class=\"list-group-item\" [routerLink]=\"['/web-dich/khoi-tao']\">Tạo mới</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web-targets/menu/menu.component.html
// module id = 932
// module chunks = 2